import { compareInsuranceMoney } from './integratedDclExports';
import { GALLAGHER_DCL_TENANT_ID } from './useIntegratedDcl';

const currency = value => typeof value === 'string' && /^[A-Z]{3}$/.test(value) ? value : null;
const exactAmount = value => {
  if (typeof value === 'number' && (!Number.isFinite(value) || Math.abs(value) > Number.MAX_SAFE_INTEGER)) return null;
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  const amount = String(value);
  return /^\d+(?:\.\d+)?$/.test(amount) && amount.length <= 100 ? amount : null;
};
export function compareKnownLimits(left, right) {
  const leftAmount = exactAmount(left?.amount), rightAmount = exactAmount(right?.amount);
  const leftCurrency = currency(left?.currency), rightCurrency = currency(right?.currency);
  if (leftAmount === null || rightAmount === null || !leftCurrency || leftCurrency !== rightCurrency) return null;
  return compareInsuranceMoney(`${leftCurrency} ${leftAmount}`, `${rightCurrency} ${rightAmount}`);
}
function currentInsuredLimit(row, assessment, { loading = false, error } = {}) {
  if (loading || error || !row?.companyId || assessment?.companyId !== row.companyId || assessment?.tenantId !== GALLAGHER_DCL_TENANT_ID) return null;
  if (assessment.stale === true || assessment.isStale === true || assessment.evaluationStale === true || assessment.freshness?.stale === true || assessment.freshness?.status === 'stale') return null;
  return assessment.insuredLimit?.state === 'known' ? assessment.insuredLimit : null;
}
export function isUnderinsuredCustomer(row, assessment, options) {
  const requested = assessment?.limitComparison?.requested;
  return requested?.state === 'known' && compareKnownLimits(currentInsuredLimit(row, assessment, options), requested) === -1;
}
export function limitIncreaseEligibility(row, assessment, options) {
  if (assessment?.limitComparison?.approvalStatus !== 'APPROVED') return { eligible: false, reason: 'A recorded internal approval is required before requesting an increase.' };
  const approved = assessment?.limitComparison?.approved;
  if (approved?.state !== 'known') return { eligible: false, reason: 'The approved limit amount and its currency need to be established.' };
  const comparison = compareKnownLimits(currentInsuredLimit(row, assessment, options), approved);
  if (comparison === null) return { eligible: false, reason: 'Current insured and approved limits need known amounts in the same explicitly recorded currency.' };
  if (comparison !== -1) return { eligible: false, reason: 'The internally approved limit must be higher than the current insured limit.' };
  return { eligible: true, reason: 'Review a request up to the recorded internal approval. The carrier makes its own decision.' };
}
